import { render } from "./DepartementsList.vue?vue&type=template&id=6d8240d5"
import script from "./DepartementsList.vue?vue&type=script&lang=js"
export * from "./DepartementsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__